import 'react-dates/initialize';
import React from 'react';
import {  Nav, NavItem, Navbar, FormControl,  Form, InputGroup  } from 'react-bootstrap';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import _ from 'lodash';

export default class SessionMenu extends React.Component {
     constructor(props) {
        super(props);
        
        
        this.state = {
            searchValue:  null,
            startDate : (props.startDate == null) ? null : moment(props.startDate, "YYYYMMDD"),
            endDate :  (props.endDate == null) ? null : moment(props.endDate, "YYYYMMDD"), 
            date : null,
            focused : false,
            focusedInput : true,
            beamlinesFilter : []              
        }
                
        this.handleSearchTermChange = this.handleSearchTermChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleBeamlineCheckbox = this.handleBeamlineCheckbox.bind(this);
        this.handleProposal = this.handleProposal.bind(this);
    }
    handleProposal(){

    }

    initBeamlines(){
        var beamlines = [];        
        for (var techniques in this.props.beamlines){            
            for (var i = 0; i < this.props.beamlines[techniques].length; i++){
                beamlines.push({
                                    name    : this.props.beamlines[techniques][i].name,
                                    checked : false                                    
                });
            }
        }
        return beamlines;
    }      

    handleBeamlineCheckbox(name, checked){                             
        var _this = this;
        if (checked){
            if (_.find(this.state.beamlines, "name") !== null){
                /** If beamline is not filtered then we filter it */
                this.setState(state => {
                    const list = state.beamlinesFilter.concat(name);   
                    _this.props.filterByBeamline(list);                                     
                    return {
                        beamlinesFilter : list                    
                    };
                });
            }
        }
        else{
            this.setState(state => {
                
                var list = _.remove(state.beamlinesFilter, function(n) {                  
                    return n !== name;
                });                
                _this.props.filterByBeamline(list);                                     
                return {
                     beamlinesFilter : list      
                };
            });
        }

    }

    handleSearchTermChange(date){     
         this.setState({
            date: date
        });
        
        let formattedDate =  moment(date).format("YYYYMMDD");
        //this.props.history.push("/sessions/" + formattedDate + "/" + formattedDate);
        this.props.fetchSessionsByDate(this.props.user, formattedDate, formattedDate);
    }

    handleDatesChange(dates){                     
        this.setState({
            startDate: dates.startDate,
            endDate: dates.endDate
        });
        if (dates.startDate != null && dates.endDate != null){        
            let startFormattedDate =  moment(dates.startDate).format("YYYYMMDD");
            let endFormattedDate =  moment(dates.endDate).format("YYYYMMDD");
            this.props.history.push("/sessions/dates/" + startFormattedDate + "/" + endFormattedDate);
            this.props.fetchSessionsByDate(this.props.user, startFormattedDate, endFormattedDate);                        
            this.props.setBreadCrumbs([{ name: 'Sessions', link: '/sessions' }, { name: "From " + this.props.startDate + " to " + this.props.endDate }]);  
        }
    }

  
    render() {         
        const checkBoxStyle = {
            marginLeft: '20px'            
        }
        
        var beamlines = { MX : [], SAXS: [], EM : []};
        if (this.props.beamlines){
            beamlines = this.props.beamlines;
        }
        return <Navbar fluid >
                <Navbar.Header>                                
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <Form inline style={{marginTop:'5px'}}>
                            <NavItem eventKey={1}>
                                    <DateRangePicker
                                            showClearDates={true}
                                            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                            startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                                            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                            endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                                            onDatesChange={this.handleDatesChange} // PropTypes.func.isRequired,
                                            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                            daySize={30}    
                                            displayFormat="DD/MM/YYYY"
                                            small = {true}  
                                            isOutsideRange = {() => false}  
                                            showDefaultInputIcon = {true}
                                            />                                                                                    
                            </NavItem>      
                        </Form>
                      
                    </Nav>
                                                           
                </Navbar.Collapse>
                </Navbar>;
    }
}
/*
 <Nav pullRight>                        
                        <NavItem eventKey={2}>
                        <Form inline style={{align:'center'}}>
                            <InputGroup>
                                        {beamlines.MX && beamlines.MX.map((value, index) => {                                            
                                            return <span style={checkBoxStyle}><input name={value.name} type="checkbox" onClick={(e) => this.handleBeamlineCheckbox(e.target.name, e.target.checked)} checked={this.state[value.name]} readOnly /><span style={{marginLeft:'5px'}}>{value.name}</span></span>                                       
                                        })}  
                                        {beamlines.SAXS && beamlines.SAXS.map((value, index) => {                                            
                                            return <span style={checkBoxStyle}><input name={value.name}  type="checkbox" onClick={(e) => this.handleBeamlineCheckbox(e.target.name, e.target.checked)} checked={this.state[value.name]} readOnly /><span style={{marginLeft:'5px'}}>{value.name}</span></span>                                       
                                        })}  
                                        {beamlines.EM && beamlines.EM.map((value, index) => {                                            
                                            return <span style={checkBoxStyle}><input name={value.name} type="checkbox" onClick={(e) => this.handleBeamlineCheckbox(e.target.name, e.target.checked)} checked={this.state[value.name]} readOnly /><span style={{marginLeft:'5px'}}>{value.name}</span></span>                                       
                                        })}                                       
                        
                                </InputGroup>
                            </Form>
                        </NavItem>
                    </Nav>             
*/


// WEBPACK FOOTER //
// ./src/components/Session/SessionMenu.js